import type { AuthUser } from "../context/AuthContext";

export type RegisterUserInput = {
  username: string;
  email: string;
  name: string;
  surname: string;
  company: string;
  country: string;
  password: string;
  role?: string;
  active: boolean;
  userGroups: string[];
};

export type RegisterUserErrorDetail = {
  field?: string;
  message?: string;
};

export type RegisterUserResult =
  | {
      ok: true;
      user: AuthUser | null;
      status: number;
    }
  | {
      ok: false;
      error: string;
      status: number;
      details?: RegisterUserErrorDetail[];
    };

export const registerUser = async (
  resolveApiPath: (value: string) => string,
  input: RegisterUserInput
): Promise<RegisterUserResult> => {
  const response = await fetch(resolveApiPath("/api/auth/register"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...input, role: input.role ?? "user" })
  });

  const data = await response.json().catch(() => null);
  if (response.ok) {
    return {
      ok: true,
      user: (data?.user as AuthUser | undefined) ?? null,
      status: response.status
    };
  }

  let message = typeof data?.error === "string" ? data.error : "Registration failed.";
  if (Array.isArray(data?.details) && data.details.length > 0) {
    const [detail] = data.details;
    if (detail && typeof detail.message === "string" && detail.message.trim().length > 0) {
      message = detail.message.trim();
    }
  }

  return {
    ok: false,
    error: message,
    status: response.status,
    details: Array.isArray(data?.details) ? (data.details as RegisterUserErrorDetail[]) : undefined
  };
};
